export default {
  badge: 'Nişan',
  close: 'Yaxın',
  dataIterator: {
    noResultsText: 'Uyğun qeydlər tapılmadı',
    loadingText: 'Elementlər yüklənir ...',
  },
  dataTable: {
    itemsPerPageText: 'Hər səhifədə satırlar:',
    ariaLabel: {
      sortDescending: 'Sırala enən.',
      sortAscending: 'Artan sıralanır.',
      sortNone: 'Çeşidlənmir.',
      activateNone: 'Çeşidləmə silmək üçün aktivləşdirin.',
      activateDescending: 'Azalanları sıralamaq üçün aktivləşdirin.',
      activateAscending: 'Artan çeşidləmə üçün aktivləşdirin.',
    },
    sortBy: 'Sırala',
  },
  dataFooter: {
    itemsPerPageText: 'Hər səhifədəki əşyalar:',
    itemsPerPageAll: 'Hamısı',
    nextPage: 'Növbəti səhifə',
    prevPage: 'Əvvəlki səhifə',
    firstPage: 'Birinci səhifə',
    lastPage: 'Son səhifə',
    pageText: '{0}-{1} of {2}',
  },
  datePicker: {
    itemsSelected: '{0} seçilib',
    nextMonthAriaLabel: 'Gələn ay',
    nextYearAriaLabel: 'Növbəti il',
    prevMonthAriaLabel: 'Əvvəlki ay',
    prevYearAriaLabel: 'Ötən il',
  },
  noDataText: 'Məlumat yoxdur',
  carousel: {
    prev: 'Əvvəlki vizual',
    next: 'Sonrakı vizual',
    ariaLabel: {
      delimiter: 'Karusel sürüşməsi {0} of {1}',
    },
  },
  calendar: {
    moreEvents: '{0} daha çox',
  },
  fileInput: {
    counter: '{0} sənədlər',
    counterSize: '{0} sənədlər ({1} Toplam)',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
  },
  pagination: {
    ariaLabel: {
      wrapper: 'Səhifənin naviqasiyası',
      next: 'Növbəti səhifə',
      previous: 'Əvvəlki səhifə',
      page: 'Səhifəyə daxil ol {0}',
      currentPage: 'Cari səhifə, Səhifə {0}',
    },
  },
};
